import React from 'react';
import styles from '../../styles/product/product-content.module.css';
import { FaCheck } from 'react-icons/fa';
import { Images } from '../images';
import ProductCta from './product-cta';

const ProductContent = props => {
  const listItems =
    props.listItems && props.listItems.length > 0
      ? props.listItems.map(item => {
          return (
            <li key={item}>
              <FaCheck /> &nbsp;{item}
            </li>
          );
        })
      : null;

  return (
    <section>
      <span className={styles.anchor} id={props.sectionSelector} />
      <div
        className={
          props.backgroundColor === 'grey'
            ? `${styles.prouctCompContainer} ${styles.greyBackground}`
            : `${styles.prouctCompContainer} ${styles.whiteBackground}`
        }
      >
        <div
          className={
            props.ImagePosition === 'left'
              ? `${styles.rowFlex} ${styles.productContentContainer}`
              : `${styles.rowReverseFlex} ${styles.productContentContainer}`
          }
        >
          <div
            className={
              props.ImagePosition === 'left'
                ? `${styles.leftImg} full-height-image`
                : `${styles.rightImg} full-height-image`
            }
          >
            <Images
              type="image"
              src={`/${props.imageTitle}`}
              altText={`${props.altText}`}
            />
          </div>
          <aside className={styles.descriptionArea}>
            <h2 className={styles.areaTitle}>{props.contentTitle}</h2>
            <h3 className={styles.areaInfo}>{props.contentDescription}</h3>
            {props.listItems && `${props.listItems}`.length > 0 ? (
              <ul className={styles.areaList}>{listItems}</ul>
            ) : (
              <ul className={styles.areaList}></ul>
            )}
            <ProductCta
              cta="Upgrade Now"
              pageTitle={props.pageTitle}
            ></ProductCta>
          </aside>
        </div>
      </div>
    </section>
  );
};
export default ProductContent;
